module.exports = __webpack_public_path__ + "img/abi发布合约.3e214da0.jpg";